export const breadcrumbIsProject = (breadCrumbNumber: number, pathNames: string[]): boolean => {
  //console.log('isProject', { pathNames }, { breadCrumbNumber })
  return pathNames[2] === 'projects'
}

export const breadcrumbIsBuilding = (breadCrumbNumber: number, pathNames: string[]): boolean => {
  //console.log('isBuilding', { pathNames }, { breadCrumbNumber })
  return pathNames[2] === 'buildings'
}
